import Gravity from 'Gravity';

const generateTableContent = () => {

    const renderCellSpans = (headCells) => {
        Array.from(headCells).reduce(
            (colSpans, th, index) => {
                const isSameContent = () => th.textContent === colSpans.content;
                const isSpanned = () => colSpans.length > 1;

                if (isSameContent()) {
                    th.remove();
                    // eslint-disable-next-line no-param-reassign
                    colSpans.length++;
                }

                //  applies colspan
                //  updates accumulator
                if (isSameContent() && isSpanned()) {
                    const firstInCol = headCells[index - colSpans.length + 1];
                    firstInCol.setAttribute('colspan', colSpans.length);
                    return colSpans;
                }

                /* eslint-disable */
                colSpans = {
                    element: th,
                    length: 1,
                    content: th.textContent,
                }
                /* eslint-enable */

                return colSpans;
            },
            { length: 0 }
        );
    };

    const renderRowSpans = (rows) => {
        const cellsToRemove = new Set();

        rows.forEach((row, rowIndex) => {
            const cells = row.querySelectorAll("td, th");
            cells.forEach((cell, cellIndex) => {
                rows.forEach((compareRow, compareRowIndex) => {
                    if (compareRowIndex <= rowIndex) { return; };
                    const compareCells = compareRow.querySelectorAll("td, th");

                    if (cell.innerHTML === compareCells[cellIndex].innerHTML) {
                        if (!cell.hasAttribute("rowspan")) {
                            cell.setAttribute("rowspan", 2);
                        }
                        cellsToRemove.add(compareCells[cellIndex]);
                    }
                });
            });
        });

        cellsToRemove.forEach(cell => cell.remove());
    };

    const setCollsColor = (cells) => {
        cells.forEach(cell => {
            // eslint-disable-next-line no-param-reassign
            cell.style = cell.querySelector('mark') ? cell.querySelector('mark').getAttribute('style') : null;
        });
    };

    document.querySelectorAll('.gg-table-v2').forEach((module) => {
        const cells = module.querySelectorAll('table tr th, table tr td');
        const rows = module.querySelectorAll('table tr');

        if (!module.classList.contains('ignore-samecontent')) {
            renderCellSpans(cells);
            renderRowSpans(rows);
        }
        setCollsColor(cells);
    });
};

Gravity.ready(generateTableContent);
